/**
 * contains the abi and contract address
*/

class MidiCCContract {
    constructor() {
        this.abi = [
	{
		"inputs": [],
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "deviceName",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "ccNumber",
				"type": "uint32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "parameterName",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "address",
				"name": "user",
				"type": "address"
			}
		],
		"name": "MidiCCParameter",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "deviceName",
				"type": "bytes32"
			},
			{
				"internalType": "uint32",
				"name": "ccNumber",
				"type": "uint32"
			},
			{
				"internalType": "bytes32",
				"name": "parameterName",
				"type": "bytes32"
			}
		],
		"name": "newMidiCCParameter",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
        ]; 
        
        this.contractAddress = '0x9c2607b1f1444AC1349aE79Bffa4000965d6936E';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default MidiCCContract;
